/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { styles } from './paypal-credit-notice.styles';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface PaypalCreditNoticeProps {
    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;
}

const StyledPaypalCreditNotice = styled('p').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const PaypalCreditNotice: FunctionComponent<PaypalCreditNoticeProps> = ({
    ...otherProps
}: PaypalCreditNoticeProps) => {
    const { t } = useTranslation();
    return (
        <StyledPaypalCreditNotice {...otherProps}>
            {t(
                'Finance provided by PayPal Credit. Terms and conditions apply. Credit subject to status. UK residents only. MPB Europe Ltd acts as a broker and offers credit solely from PayPal Credit, a trading name of PayPal UK Ltd, 5 Fleet Place, London, United Kingdom, EC4M 7RD.'
            )}
        </StyledPaypalCreditNotice>
    );
};
